import React, {useEffect, useState} from 'react';
import CustomLink from "../../../components/UI/customLink/customLink";
import UserTable from "../../../components/table/user-table";
import {useTranslation} from "react-i18next";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import CustomInput from "../../../components/UI/customInput/customInput";
import CustomButton from "../../../components/UI/customButton/customButton";
import {Get, Post} from "../../../apis/api";
import {toast} from "react-toastify";
import CustomSelect from "../../../components/UI/customSelect/customSelect";
import LoadingFix from "../../../components/loading-fix/loading-fix";
import {Close} from "../../../icons/icons";
import CustomCheckBox from "../../../components/UI/customCheckBox/customCheckBox";
import Search from "../../../components/search/search";
import moment from "moment-jalaali";
import ShipTable from "../../../components/table/ship-table";

const NewUser = () => {
  const {t} = useTranslation();
  const [form, setForm] = useState({})
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [shipModal, setShipModal] = useState(false)
  const [dockModal, setDockModal] = useState(false)
  const [data, setData] = useState( [])
  const [dockList, setDockList] = useState( [])
  const [shipList, setShipList] = useState( [])
  const [roleList, setRoleList] = useState( [])
  const [dock, setDock] = useState( [])
  const [ship, setShip] = useState( [])
  const [searchTime, setSearchTime] = useState("")

  const [editId, setEditId] = useState(null)
  const navigate = useNavigate();

  const param = useParams()
  useEffect(() => {
    handleList()
    if(param.id) {
      handleOldData()
      handleRoleList()
    }
  } ,[])

  const location = useLocation()


  const handleOldData = () => {
    setLoading(true)
    Get(`admin/users/show/${param.id}` ).then((res) =>{
      setForm(res?.details?.data)
      setShipList(handleClear(res?.details?.data?.ships))
      setDockList(handleClear(res?.details?.data?.docks))
    }).finally(() => {
      setLoading(false)
    })
  }

  const handleRoleList = () => {
    setLoading(true)
    Get(`roles` ).then((res) =>{
      setRoleList(res?.details)
    }).finally(() => {
      setLoading(false)
    })
  }


  const handleList = (page , per_page, search="") => {
    setLoading(true)
    Get(`roles?page=${page || 1}&per_page=${per_page || 10}&q=${search}` ).then((res) =>{
      setData(res?.details)
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    handleList()
    handleListShipAndDock(1 , 100 , "" , true , true)
  } ,[])



  const handleListShipAndDock = (page , per_page, search="" , ship = false , dock = false) => {
    if(dock)
    Get(`basic-information/dock?page=${page || 1}&per_page=${per_page || 100}&q=${search}` ).then((res) =>{
      setDock(res?.details?.data)
    }).finally(() => {
    })
    if(ship)
    Get(`basic-information/ship?page=${page || 1}&per_page=${per_page || 100}&q=${search}` ).then((res) =>{
      setShip(res?.details?.data)
    }).finally(() => {
    })
  }

  const handleVisa = () => {
    const newList = []
    data?.forEach((item) => {
      newList.push({fa_name: item?.title , en_name: item?.title , id:item.role_key})
    })
    return newList
  }
  const handleRole = (id) => {

    return roleList?.find((item => {
      return (
        item.role_key === id
      )
    }))
  }
  const handleSubmit = () => {
    setLoading(true)
    Post(`admin/users/${param.id ? `update/${param.id}` :"store"}` , {form : "update_form" , ...form , "docks" : dockList , "ships":shipList , mobile_verified_at:param.id ? (form.mobile_verified_at ? moment(form.mobile_verified_at).format('YYYY-MM-jDD') : moment(new Date()).format('YYYY-MM-jDD')) : null  , ...(!!form?.pay_back_percent ? ({pay_back_percent:parseFloat(form?.pay_back_percent)}) : ({}))}).then((res) =>{
      toast.success(res.msg)
      if(!param.id) {
        navigate("/basic-information/users")
      }
    }).catch((error) => {

      toast.error(error?.data?.message)
    })
      .finally(() => {
        setLoading(false)
      })
  }
  const handleForm = ({name, value}) => {
    setForm((prevState) => ({...prevState, [name]: value}))
  }


  const handleDock = (e) => {
    const newList = [...dockList];
    const find = newList.findIndex((item) => item === e);
    if (find !== -1) {
      newList.splice(find, 1);
    } else {
      newList.push(e);
    }
    setDockList(newList);
  }


  const handleShip = (e) => {
    const newList = [...shipList];
    const find = newList.findIndex((item) => item === e);
    if (find !== -1) {
      newList.splice(find, 1);
    } else {
      newList.push(e);
    }
    setShipList(newList);
  };

  const handleSearch = (e) => {

    clearTimeout(searchTime)


    let loop = setTimeout(() => {

      handleListShipAndDock(1 , 100 , e, shipModal , dockModal);

    }, 1000)
    setSearchTime(loop)

  }

  const handleDefault = (option , defaultValue) => {
    return defaultValue?.find((item) => {
      return option.id === item.id
    })
  }

  const handleClear = (option) => {
     let newList = []
     option?.forEach((item) => {
       newList.push(item.id)
     })
    return newList
  }



  return (
    <div className={"flex flex-col w-full pb-32"}>
      {
        loading && <LoadingFix/>
      }
      <div className={"my-container rounded-lg  flex flex-col justify-between items-center w-full"}>
         <div className={"w-full flex justify-between items-center"}>
           <Link to={"/basic-information/users"} className={"text-main"}>
             {t("back")}
           </Link>
           {
             !location.pathname?.includes("new") &&
             <div className={"w-[207px]"}>
               <CustomLink link={"/basic-information/user/new"} title={t("newUser")}/>
             </div>
           }

         </div>
        <div className={"w-full"}>
          <div
            className="relative py-5 px-4 md:px-44  w-full  bg-white rounded-lg  flex flex-col items-center w-full !mt-5 border border-1 border-gray-300 ">
            <p className={"text-gray-500 leading-6 "}>
              {t("titleUser")}
            </p>
            <div className={"flex flex-col gap-5 w-full"}>
            <span className={"w-full mt-7"}>
               <CustomInput
                 placeHolder={t("name")}
                 label={t("name")}
                 name={"name"}
                 defaultValue={form["name"]}
                 onchange={(e) => handleForm(e)}
               />
            </span>
            <span className={"w-full"}>
               <CustomInput
                 placeHolder={ t("family")}
                 label={ t("family")}
                 name={"last_name"}
                 defaultValue={form["last_name"]}
                 onchange={(e) => handleForm(e)}
               />
            </span>

              <span className={"w-full"}>
                 <CustomSelect
                   name="role_key"
                   label={t("roles")}
                   options={handleVisa()}
                   onchange={(e) => handleForm(e)}
                   defaultValue={handleRole(form["role_key"])}
                 />

            </span>
              <div className={"flex gap-5"}>
               <span className={"w-full"}>
                 <CustomInput
                   placeHolder={t("phoneNumber")}
                   label={t("phoneNumber")}
                   name={"mobile"}
                   defaultValue={form["mobile"]}
                   onchange={(e) => handleForm(e)}
                 />
              </span>
                {/*<div className={"w-[100px]"}>*/}
                {/*  <CustomButton styles={"text-sm"} title={t("confirmation")}/>*/}
                {/*</div>*/}
              </div>
              <div className={"flex gap-5"}>
               <span className={"w-full"}>
                 <CustomInput
                   placeHolder={t("CancelReturnPercent")}
                   label={t("CancelReturnPercent")}
                   name={"pay_back_percent"}
                   defaultValue={form["pay_back_percent"]}
                   onchange={(e) => handleForm(e)}
                   type='number'
                   min={0}
                   max={100}
                 />
              </span>
                {/*<div className={"w-[100px]"}>*/}
                {/*  <CustomButton styles={"text-sm"} title={t("confirmation")}/>*/}
                {/*</div>*/}
              </div>
              <div className={"flex gap-5"}>
               <span className={"w-full"}>
                 <CustomInput
                   placeHolder={t("email")}
                   label={t("email")}
                   name={"email"}
                   defaultValue={form["email"]}
                   onchange={(e) => handleForm(e)}
                 />
              </span>
                {/*<div className={"w-[100px]"}>*/}
                {/*  <CustomButton styles={"text-sm"} title={t("confirmation")}/>*/}
                {/*</div>*/}
              </div>


            </div>
          </div>
        </div>
      </div>
      <ShipTable onClose={() => console.log("a")} onClear={() => console.log("s")} defaultValueSelected={shipList}  onChange={(e) => handleShip(e)} selectShip={true}/>
      <div className={"w-full my-container mt-5 flex justify-end"}>
        <div className={"w-[300px]"}>
          <CustomButton loading={loading} onClick={handleSubmit}  styles={"text-sm"} title={t("save")}/>
        </div>
      </div>
    </div>
  );
};

export default NewUser;
